// extracted by mini-css-extract-plugin
export default {"mainHeader":"header_mainHeader__q9wHM","headerLogo":"header_headerLogo__Fslxs","headerTitle":"header_headerTitle__wRKjp"};